<button
  mat-icon-button
  cdkOverlayOrigin
  [matTooltip]="tooltipControl.value"
  matTooltipPosition="above"
  type="button"
  (click)="openWithConfig($event)"
>
  <mat-icon svgIcon="help"></mat-icon>
</button>
